import { MAIN_MENU, MENU_GROUPS, getMenuIcon, isItemAllowedForState, resolveMenuHref } from "@/config/mainMenu";
import { getNavLabel } from "@/config/navigation";

const PUBLIC_USER_STATE = { isGuest: false, isLoggedIn: true, isFree: true, isPremium: true, isAdmin: false };

export const navigationGroups = MENU_GROUPS.filter((group) => group.key !== "admin").map((group) => ({
  key: group.key,
  label: getNavLabel(group.labelKey, "en"),
  items: MAIN_MENU
    .filter((item) => item.group === group.key && isItemAllowedForState(item, PUBLIC_USER_STATE, "app"))
    .map((item) => ({
      key: item.key,
      icon: getMenuIcon(item.icon),
      label: getNavLabel(item.labelKey, "en"),
      path: resolveMenuHref(item, "app", "en"),
      zone: item.zone,
      tier: item.tier,
    }))
    .filter((item) => item.path),
})).filter((group) => group.items.length > 0);

export const adminNavigationItems = MAIN_MENU
  .filter((item) => item.zone === "admin")
  .map((item) => ({ key: item.key, icon: getMenuIcon(item.icon), label: getNavLabel(item.labelKey, "en"), path: item.appHref }));

export const mobileNavigationTabs = [
  navigationGroups[0],
  navigationGroups[1],
  navigationGroups[2],
  navigationGroups[3],
  { label: "More", items: [...(navigationGroups[4]?.items || []), ...(navigationGroups[5]?.items || [])] },
].filter(Boolean);

export const duplicateRedirects = {
  "/education": "/en/learning-center",
  "/route-library": "/routes",
  "/log-analytics": "/metrics",
  "/ports": "/marinas",
  "/user-flow": "/en/",
};

export function pathSlug(path = "") {
  return path.split("?")[0].split("/").filter(Boolean).pop() || "home";
}

export function isNavPathActive(currentPath, targetPath) {
  const currentSlug = pathSlug(currentPath);
  const targetSlug = pathSlug(targetPath);
  if (targetPath === "/") return currentPath === "/" || currentPath === "/en" || currentPath === "/en/";
  return currentSlug === targetSlug || currentPath.includes(`/${targetSlug}/`);
}